var map = {
	"./倒數開始_0.png": "59d5",
	"./倒數開始_1.png": "0390",
	"./倒數開始_2.png": "62cb",
	"./倒數開始_3.png": "8433",
	"./倒數開始_壓黑.png": "cddb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7c1e";